/**
 * Funções Utilitárias para o Modal de Exercícios
 *
 * Responsabilidade:
 * - Validar arquivos (imagem e vídeo) quanto ao tamanho.
 * - Ler arquivos e converter para Base64.
 * - Manter funções puras que não dependem do estado do componente.
 */

import { toast } from "react-toastify";

export const validateImage = (file: File): boolean => {
  const maxSize = 5 * 1024 * 1024; // 5MB
  if (file.size > maxSize) {
    toast.error("A imagem deve ter no máximo 5MB");
    return false;
  }
  return true;
};

export const validateVideo = (file: File): boolean => {
  const maxSize = 50 * 1024 * 1024; // 50MB
  if (file.size > maxSize) {
    toast.error("O vídeo deve ter no máximo 50MB");
    return false;
  }
  return true;
};

export const readFileAsBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result as string);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};
